import { render, staticRenderFns } from "./CameraPlatform.vue?vue&type=template&id=ce8df396&scoped=true&"
import script from "./CameraPlatform.vue?vue&type=script&lang=js&"
export * from "./CameraPlatform.vue?vue&type=script&lang=js&"
import style0 from "./CameraPlatform.vue?vue&type=style&index=0&id=ce8df396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8df396",
  null
  
)

export default component.exports